<input type="hidden" [value]="item.value" [name]="item.name" />

